import React, { useEffect } from "react";
import Hero from "../components/Hero";
import ServicesOverview from "../components/ServicesOverview";
import TechnologyStack from "../components/TechnologyStack";
import ClientSuccess from "../components/ClientSuccess";
import ServiceCards from "../components/ServiceCards";
import AIFeatures from "../components/AIFeatures";
import ResourcesHub from "../components/ResourcesHub";

const Home = () => {
  useEffect(() => {
    // Handle hash navigation when component mounts
    const hash = window.location.hash.substring(1);
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, []);

  return (
    <main className="container mx-auto px-6 py-12">
      <Hero />
      <ServicesOverview />
      <ServiceCards />
      <TechnologyStack />
      <ClientSuccess />
      <AIFeatures />
      <ResourcesHub />
    </main>
  );
};

export default Home;
